import { render } from "./ThreadMasterDetail.vue?vue&type=template&id=b59b0ece&scoped=true&ts=true"
import script from "./ThreadMasterDetail.vue?vue&type=script&lang=ts"
export * from "./ThreadMasterDetail.vue?vue&type=script&lang=ts"

import "./ThreadMasterDetail.vue?vue&type=style&index=0&id=b59b0ece&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b59b0ece"]])

export default __exports__